/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RoutedMessagesView.vue?vue&type=template&id=39afaea6&scoped=true"
import script from "./RoutedMessagesView.vue?vue&type=script&lang=js"
export * from "./RoutedMessagesView.vue?vue&type=script&lang=js"
import style0 from "./RoutedMessagesView.vue?vue&type=style&index=0&id=39afaea6&scoped=true&lang=css"
import style1 from "./RoutedMessagesView.vue?vue&type=style&index=1&id=39afaea6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39afaea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39afaea6')) {
      api.createRecord('39afaea6', component.options)
    } else {
      api.reload('39afaea6', component.options)
    }
    module.hot.accept("./RoutedMessagesView.vue?vue&type=template&id=39afaea6&scoped=true", function () {
      api.rerender('39afaea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RoutedMessagesView.vue"
export default component.exports